import { useId } from 'react';
import { UI_SYMBOL_SPRITE_PATH, type UiSymbolName } from '../../content/assets/uiSymbols';

interface SvgIconProps {
  name: UiSymbolName;
  title?: string;
  className?: string;
}

export function SvgIcon({ name, title, className }: SvgIconProps) {
  const titleId = useId();

  return (
    <svg
      className={['svg-icon', className].filter(Boolean).join(' ')}
      role={title ? 'img' : undefined}
      aria-hidden={title ? undefined : true}
      aria-labelledby={title ? titleId : undefined}
      focusable="false"
    >
      {title ? <title id={titleId}>{title}</title> : null}
      <use href={`${UI_SYMBOL_SPRITE_PATH}#${name}`} />
    </svg>
  );
}
